// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main App Layout */
.app-content {
  min-height: calc(100vh - 70px);
  padding-top: 0;
}

/* Page Layouts */
.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.page-container-narrow {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.page-title {
  font-size: 2.5rem;
  color: #1a1a2e;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e0e0e0;
}

/* Landing Page Styles */
.landing-page {
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: white;
  text-align: center;
  padding: 2rem;
  position: relative;
}

.landing-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 26, 46, 0.7);
  z-index: 1;
}

.landing-hero {
  max-width: 800px;
  position: relative;
  z-index: 2;
}

.landing-title {
  font-size: 4rem;
  margin-bottom: 1rem;
  color: #4ecca3;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0, 0.5);
}

.landing-subtitle {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
}

.landing-description {
  font-size: 1.125rem;
  margin-bottom: 3rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.8;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}

.landing-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.landing-btn {
  padding: 1rem 2rem;
  font-size: 1.125rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.landing-btn-primary {
  background-color: #4ecca3;
  color: #1a1a2e;
}

.landing-btn-primary:hover {
  background-color: #3db88a;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(78, 204, 163, 0.3);
}

.landing-btn-secondary {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}

.landing-btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .page-container,
  .page-container-narrow {
    padding: 1rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .landing-title {
    font-size: 2.5rem;
  }

  .landing-subtitle {
    font-size: 1.25rem;
  }

  .landing-description {
    font-size: 1rem;
  }

  .landing-actions {
    flex-direction: column;
    width: 100%;
  }

  .landing-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,wEAAwE;AAC1E;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Main App Layout */\n.app-content {\n  min-height: calc(100vh - 70px);\n  padding-top: 0;\n}\n\n/* Page Layouts */\n.page-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.page-container-narrow {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.page-title {\n  font-size: 2.5rem;\n  color: #1a1a2e;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n/* Landing Page Styles */\n.landing-page {\n  min-height: calc(100vh - 70px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  color: white;\n  text-align: center;\n  padding: 2rem;\n  position: relative;\n}\n\n.landing-page::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(26, 26, 46, 0.7);\n  z-index: 1;\n}\n\n.landing-hero {\n  max-width: 800px;\n  position: relative;\n  z-index: 2;\n}\n\n.landing-title {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  color: #4ecca3;\n  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0, 0.5);\n}\n\n.landing-subtitle {\n  font-size: 1.5rem;\n  margin-bottom: 2rem;\n  color: rgba(255, 255, 255, 0.95);\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);\n}\n\n.landing-description {\n  font-size: 1.125rem;\n  margin-bottom: 3rem;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.8;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n.landing-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.landing-btn {\n  padding: 1rem 2rem;\n  font-size: 1.125rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.landing-btn-primary {\n  background-color: #4ecca3;\n  color: #1a1a2e;\n}\n\n.landing-btn-primary:hover {\n  background-color: #3db88a;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(78, 204, 163, 0.3);\n}\n\n.landing-btn-secondary {\n  background-color: transparent;\n  color: white;\n  border: 2px solid white;\n}\n\n.landing-btn-secondary:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .page-container,\n  .page-container-narrow {\n    padding: 1rem;\n  }\n\n  .page-title {\n    font-size: 2rem;\n  }\n\n  .landing-title {\n    font-size: 2.5rem;\n  }\n\n  .landing-subtitle {\n    font-size: 1.25rem;\n  }\n\n  .landing-description {\n    font-size: 1rem;\n  }\n\n  .landing-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .landing-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
